"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// src/components/table/MainTable.tsx
var react_1 = __importStar(require("react"));
var StyledTable_1 = __importDefault(require("./StyledTable"));
var math_helper_1 = require("../../helpers/math-helper");
var MainTable = function (_a) {
    var rows = _a.rows, columns = _a.columns, heading = _a.heading, actionSelector = _a.actionSelector, page = _a.page, setPage = _a.setPage, rowsPerPage = _a.rowsPerPage, setRowsPerPage = _a.setRowsPerPage, handleChangePage = _a.handleChangePage, handleChangeRowsPerPage = _a.handleChangeRowsPerPage, optionsObject = _a.optionsObject, rowSelector = _a.rowSelector, rowsCount = _a.rowsCount, actionText = _a.actionText, _b = _a.actionDisabled, actionDisabled = _b === void 0 ? false : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.noCustomizeColumn, noCustomizeColumn = _d === void 0 ? false : _d, _e = _a.frontendSort, frontendSort = _e === void 0 ? false : _e, _f = _a.containerHeight, containerHeight = _f === void 0 ? "59vh" : _f, _g = _a.paginationMargin, paginationMargin = _g === void 0 ? null : _g, _h = _a.isEditable, isEditable = _h === void 0 ? false : _h, currentRow = _a.currentRow, setCurrentRow = _a.setCurrentRow, setRows = _a.setRows, themeMode = _a.themeMode;
    var savedVisibleColumns = function () {
        if (noCustomizeColumn) {
            return columns.map(function (col) { return col.renderName; });
        }
        else {
            var savedVisibleColumns_1 = localStorage.getItem("visibleColumns");
            return savedVisibleColumns_1
                ? JSON.parse(savedVisibleColumns_1)
                : columns.map(function (col) { return col.renderName; });
        }
    };
    var _j = (0, react_1.useState)(savedVisibleColumns), visibleColumns = _j[0], setVisibleColumns = _j[1];
    var _k = (0, react_1.useState)(rows), originalRows = _k[0], setOriginalRows = _k[1];
    var _l = (0, react_1.useState)([]), sortedRows = _l[0], setSortedRows = _l[1];
    var _m = (0, react_1.useState)({
        field: "",
        direction: "asc",
    }), sortModel = _m[0], setSortModel = _m[1];
    var sortRows = function (rows, _a) {
        var field = _a.field, direction = _a.direction;
        if (!field)
            return rows;
        var compare = function (a, b) {
            var valA = a[field];
            var valB = b[field];
            if (typeof valA === "string" && typeof valB === "string") {
                var regex = /^[\D]*[\d,]+\.?\d*$/;
                if (regex.test(valA) && regex.test(valB)) {
                    valA = (0, math_helper_1.cleanNumericString)(valA);
                    valB = (0, math_helper_1.cleanNumericString)(valB);
                }
                else {
                    valA = valA.toLowerCase();
                    valB = valB.toLowerCase();
                }
            }
            if (valA < valB) {
                return direction === "asc" ? -1 : 1;
            }
            if (valA > valB) {
                return direction === "asc" ? 1 : -1;
            }
            return 0;
        };
        return __spreadArray([], rows, true).sort(compare);
    };
    (0, react_1.useEffect)(function () {
        setOriginalRows(rows);
    }, [rows]);
    (0, react_1.useEffect)(function () {
        setSortedRows(sortRows(originalRows, sortModel));
    }, [originalRows, sortModel]);
    (0, react_1.useEffect)(function () {
        localStorage.setItem("visibleColumns", JSON.stringify(visibleColumns));
    }, [visibleColumns]);
    return (react_1.default.createElement(StyledTable_1.default, { rows: sortedRows, columns: columns, heading: heading, actionSelector: actionSelector, page: page, setPage: setPage, rowsPerPage: rowsPerPage, setRowsPerPage: setRowsPerPage, handleChangePage: handleChangePage, handleChangeRowsPerPage: handleChangeRowsPerPage, optionsObject: optionsObject, rowSelector: rowSelector, rowsCount: rowsCount, actionText: actionText, actionDisabled: actionDisabled, isLoading: isLoading, visibleColumns: visibleColumns, setVisibleColumns: setVisibleColumns, noCustomizeColumn: noCustomizeColumn, sortModel: sortModel, onSortModelChange: setSortModel, frontendSort: frontendSort, containerHeight: containerHeight, paginationMargin: paginationMargin, isEditable: isEditable, currentRow: currentRow, setCurrentRow: setCurrentRow, setRows: setRows, themeMode: themeMode }));
};
exports.default = MainTable;
